import axios from 'axios';

export async function storeSessionPage(pageObj) {
  try {
    const res = await axios.post(
      `/session-pages`,
      { pageObj },
    );
    return res.data;
  } catch (err) {
    console.error(err);
  }
}

export async function saveSessionEnd(clearSession) {
  try {
    const res = await axios.post('/session-end', { clearSession });
    return res.data;
  } catch (err) {
    console.error(err);
  }
}

export async function setPageId(pageObj) {
  try {
    const res = await axios.post(
      `/session-pages`,
      { pageObj },
    );
    return res.data;
  } catch (err) {
    console.error(err);
  }
}

export async function updateElapsedTimeInSecs(elapsedTimeInSecs) {
  try {
    const res = await axios.post(
      `/session-pages/elapsed-time`,
      { elapsedTimeInSecs },
    );
    return res.data;
  } catch (err) {
    console.error(err);
  }
}

export const createReservationCheckInRating = async (ratingId) => {
  return (await axios.post(`/reservation-check-in-rate`, { ratingId })).data
}

export const setReservationCheckInRatingObservations = async (observations) => {
  return (await axios.post(`/reservation-check-in-rate/observations`, { observations })).data
}

/**
 * GKIOSK-1889 - linha de diagnostico gravada em SESSION.LOGS. Escreve de imediato (o kiosk-stand
 * acumula num buffer e faz flush no fim da sessao, mas o mobile nao tem esse ponto de flush).
 */
export async function saveSessionLogs(logs) {
  try {
    const res = await axios.post('/save-session-logs', { logs });
    return res.data;
  } catch (err) {
    console.error(err);
  }
}

export async function savePackBasicAction(value) {
  try {
    const res = await axios.post(
      `/pack-basic-response`,
      {
        accept: value
      }
    );
    return res.data;
  } catch (err) {
    console.error(err);
  }
}
